
export class Admin {
  public id: number;
  public name: string;
  public surname: string;
  public prefix: string;

  constructor(server_obj) {
    this.prefix = 'admin_';
    if (server_obj) {
      this.id = Number(server_obj[this.prefix + 'id']);
      this.name = server_obj[this.prefix + 'name'];
      this.surname = server_obj[this.prefix + 'surname'];
    }
  }
}
